import { ReactProductState } from "product";
import { FC } from "react";
import { StoreApi, UseBoundStore } from "zustand";

export const ProductPrice: FC<{ useProduct: UseBoundStore<StoreApi<ReactProductState>> }> = ({
  useProduct,
}) => {
  const { selectedVariant, selectedSellingPlan } = useProduct(
    ({ selectedVariant, selectedSellingPlan }) => ({
      selectedVariant,
      selectedSellingPlan,
    })
  );

  const comparePrice =
    selectedSellingPlan?.compare_at_price ??
    selectedVariant?.compare_at_price ??
    selectedVariant?.price;
  const price = selectedSellingPlan?.price ?? selectedVariant?.price;
  const isOnSale = comparePrice > price;
  const savings = isOnSale ? comparePrice - price : 0;

  return (
    <div className="product-price flex items-center justify-start gap-2 whitespace-nowrap">
      {isOnSale ? (
        <span
          className="text-[#AAAAAA] line-through"
          dangerouslySetInnerHTML={{
            __html: window.formatMoney(comparePrice),
          }}
        ></span>
      ) : null}
      <span 
        className={isOnSale ? "text-[#D5213F]" : ""}
        dangerouslySetInnerHTML={{ __html: window.formatMoney(price) }}
      ></span>
      {isOnSale && (
        <span className="text-xs bg-[#D5213F] text-white px-2 py-0.5 rounded-full">
          Save {window.formatMoney(savings)}
        </span>
      )}
    </div>
  );
};
